module.exports = __webpack_public_path__ + "static/media/slalom.f1c6fd68.png";